"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SocketEvent = void 0;
var SocketEvent;
(function (SocketEvent) {
    SocketEvent["AUTH"] = "auth";
    SocketEvent["LOGOUT"] = "logout";
    SocketEvent["JOIN"] = "join";
    SocketEvent["JOINED"] = "joined";
    SocketEvent["NEW"] = "new";
    SocketEvent["EDIT"] = "edit";
    SocketEvent["REMOVE"] = "remove";
    SocketEvent["TYPING"] = "typing";
    SocketEvent["STOP_TYPING"] = "stop_typing";
    SocketEvent["LEAVE"] = "leave";
    SocketEvent["DISCONNECT"] = "disconnect";
    SocketEvent["CONNECT_ERROR"] = "connect_error";
    SocketEvent["CONNECT_FAILED"] = "connect_failed";
})(SocketEvent || (exports.SocketEvent = SocketEvent = {}));
